import { render, staticRenderFns } from "./MyMindContent.vue?vue&type=template&id=2a9c1570"
import script from "./MyMindContent.vue?vue&type=script&lang=js"
export * from "./MyMindContent.vue?vue&type=script&lang=js"
import style0 from "./MyMindContent.vue?vue&type=style&index=0&id=2a9c1570&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports